module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_44.79798be6.png";